<template>
  <div class="text-center">
    <div class="flex justify-center">
      <button class="mr-10 rounded-full focus:outline-black-alt" :class="showNoFeedback ? 'pointer-events-none' : ''" @click="clickYes">
        <ellevio-web-thumb :up="true" :color="colorLeft" :clickedYes="clickedYes" />
        <span class="sr-only">{{ buttonFeedbackTextYes }}</span>
      </button>
      <button class="rounded-full focus:outline-black-alt" :class="showYesFeedback ? 'pointer-events-none' : ''" @click="clickNo">
        <ellevio-web-thumb :up="false" :color="colorRight" :clickedNo="clickedNo" />
        <span class="sr-only">{{ buttonFeedbackTextNo }}</span>
      </button>
    </div>
    <div v-if="showInputField" class="text-left mt-7">
      <label for="feedback-text" class="text-2xl font-futuraEfDemiBold">{{ inputHeading }}</label>
      <textarea
        id="feedback-text"
        v-model="inputFieldValue"
        rows="4"
        class="block w-full max-w-full p-2 my-3 text-lg font-normal rounded-lg border-1 border-newColors-gray-baseB placeholder:italic font-futuraEfBook focus:outline-none focus:shadow-mp hover:shadow-mp focus:border-newColors-gray-contentD hover:border-newColors-gray-contentD"
        :placeholder="feedbackPlaceholder" />
      <div class="flex flex-col justify-between md:items-center md:flex-row md:gap-8 md:text-right">
        <button class="btn-primary" :disabled="inputFieldValue.length == 0" @click="sendMessage">
          {{ buttonText }}
        </button>
        <div v-if="explanation.length > 0" v-html="explanation" class="mt-3 explanation md:mt-0"></div>
      </div>
    </div>
    <div v-if="showYesFeedback" class="mt-5">
      <div class="flex justify-center">
        <h3 class="mr-2 text-3xl">{{ feedbackThankYouHeading }}</h3>
        <ellevio-web-sparkle-icon-animated />
      </div>
      <p class="mt-1 text-lg">{{ feedbackYesText }}</p>
    </div>
    <div v-if="messageSent" class="mt-5">
      <div class="flex justify-center">
        <h3 class="mr-2 text-3xl">{{ feedbackThankYouHeading }}</h3>
        <ellevio-web-sparkle-icon-animated />
      </div>
      <p class="mt-1 text-lg">{{ feedbackNoText }}</p>
    </div>
  </div>
</template>

<script>
import apiUrl from '../../../helpers/apiUrl'
import gtmHelper from '../../../helpers/gtmHelper'
import axios from 'axios'
import EllevioWebThumb from './thumb.vue'
import EllevioWebSparkleIconAnimated from './SparkleIconAnimated.vue'

const COLOR_BLACK = '#2C2827'
const COLOR_RED = '#CE1F36'
const COLOR_GREEN = '#10A76B'

export default {
  name: 'EllevioWebFeedbackForm',
  components: {
    EllevioWebThumb,
    EllevioWebSparkleIconAnimated
  },
  props: {
    inputHeading: {
      type: String,
      default: 'Varför hjälpte inte sidan dig?'
    },
    buttonText: {
      type: String,
      default: 'Skicka'
    },
    feedbackThankYouHeading: {
      type: String,
      default: 'Tack!'
    },
    feedbackYesText: {
      type: String,
      default: 'Tack så mycket, vi uppskattar din feedback!'
    },
    feedbackNoText: {
      type: String,
      default: 'Skickat - Vi uppskattar din feedback!'
    },
    buttonFeedbackTextYes: {
      type: String,
      default: 'Ja - den hjälpte mig'
    },
    buttonFeedbackTextNo: {
      type: String,
      default: 'Nej - den hjälpte mig inte'
    },
    contentId: {
      type: String,
      default: '0'
    },
    language: {
      type: String,
      default: 'sv'
    },
    faqfeedback: {
      type: Boolean,
      default: false
    },
    explanation: {
      type: String,
      default: ''
    },
    feedbackPlaceholder: {
      type: String,
      default: 'Ge feedback på sidan och berätta om din upplevelse..'
    }
  },
  data: function () {
    return {
      showYesFeedback: false,
      showNoFeedback: false,
      showInputField: false,
      messageSent: false,
      inputFieldValue: '',
      colorRight: COLOR_BLACK,
      colorLeft: COLOR_BLACK,
      clickedNo: false,
      clickedYes: false
    }
  },
  methods: {
    clickYes: async function () {
      this.clickedYes = true
      if (this.showYesFeedback || this.showNoFeedback) return

      this.colorLeft = COLOR_GREEN
      this.colorRight = COLOR_BLACK

      this.showInputField = false
      this.showYesFeedback = true
      this.pushToDataLayer('yes')
      //this.pushToEpiserver('yes', '')
    },
    clickNo: async function () {
      this.clickedNo = true
      if (this.showYesFeedback || this.showNoFeedback) return

      this.colorRight = COLOR_RED
      this.colorLeft = COLOR_BLACK

      this.showNoFeedback = true
      this.showInputField = !this.showInputField
      this.pushToDataLayer('no')
      //this.pushToEpiserver('no', '')
    },
    sendMessage: async function () {
      if (this.inputFieldValue.length == 0) return

      this.showNoFeedback = true
      this.showInputField = false
      this.messageSent = true

      this.pushToDataLayer('message')
      this.pushToEpiserver(this.inputFieldValue)
    },
    pushToDataLayer: function (action) {
      gtmHelper.sendFeedback(action)
    },
    pushToEpiserver: async function (inputValue = '') {
      //const response =
      await axios.post(apiUrl.postFeedback, {
        ContentId: this.contentId,
        Language: this.language,
        Feedback: inputValue,
        FaqFeedback: this.faqfeedback
      })
    }
  }
}
</script>
<style>
.explanation p {
  @apply text-lg;
}
.explanation a {
  text-decoration: underline;
}
</style>
